var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9025 3.90241C0.921497 6.88341 0.921497 11.7166 3.9025 14.6976C6.8835 17.6786 11.7167 17.6786 14.6977 14.6976C17.6787 11.7166 17.6787 6.88341 14.6977 3.90241C11.7167 0.921406 6.8835 0.921406 3.9025 3.90241ZM5.08101 5.08092C7.41114 2.75079 11.189 2.75079 13.5192 5.08092C15.8493 7.41105 15.8493 11.1889 13.5192 13.5191C11.189 15.8492 7.41114 15.8492 5.08101 13.5191C2.75088 11.1889 2.75088 7.41105 5.08101 5.08092Z",
    fill: "#92929D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.412 16.9021L14.9708 13.4608C14.1851 12.6752 13.0066 13.8537 13.7923 14.6393L17.2335 18.0806C18.0192 18.8662 19.1977 17.6877 18.412 16.9021Z",
    fill: "#92929D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.73f6dddc85dfd7908f2e9833df31b10b.svg";
export { ForwardRef as ReactComponent };